import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { SmartRewardsService } from './smart-rewards.service';

export const SmartRewardsResolver: ResolveFn<any> = () => {
    return inject(SmartRewardsService).getClientContent();
};
